export const ROLE_PATHS: Record<string, string> = {
  'ROLE_DESIGNER': '/records/wildberries-product-cards',
  'ROLE_PURCHASING_MANAGER': '/records/technical-parameters',
  'ROLE_MARKETPLACE_MANAGER': '/records/wildberries-product-cards',
  'ROLE_MARKETPLACE_HEAD': '/records/wildberries-product-cards',
  'ROLE_BRAND_MANAGER': '/records/wildberries-product-cards'
} as const;

export const DEFAULT_RECORD_PATH = '/records/record-lists';
